<template>
    <b-col class="AddNewFamily">
        <b-form class="full-width" @submit="AddFamily">
            <b-row>
                <b-col lg="6">
                    <h2>First Parent</h2>
                    <div class="form-group">
                        <label>First Name:</label>
                        <input type="text" v-model="NewFamily.Parent1FirstName" class="form-control" required />
                    </div>
                    <div class="form-group">
                        <label>Last Name:</label>
                        <input type="text" v-model="NewFamily.Parent1LastName" class="form-control" required />
                    </div>
                    <div class="form-group">
                        <label>DOB:</label>
                        <flat-pickr v-model="NewFamily.Parent1DOB" class="form-control" :config="DateConfig"></flat-pickr>
                    </div>
                    <label>Sex:</label>
                    <select class="form-control" v-model="NewFamily.Parent1SexID" required>
                        <option v-for="option in SexOptions" :value="option.value">
                            {{option.text}}
                        </option>
                    </select>
                </b-col>
                <b-col lg="6">
                    <h2><font-awesome-icon v-if="Parent2On == false" :icon="['fa', 'plus']" class="olive-green-text pointer" @click="Parent2Toggle" /><font-awesome-icon v-if="Parent2On == true" :icon="['fa', 'minus']" class="red pointer" @click="Parent2Toggle" /> Second Parent</h2>
                    <div v-if="Parent2On">
                        <div class="form-group">
                            <label>First Name:</label>
                            <input type="text" v-model="NewFamily.Parent2FirstName" class="form-control" required />
                        </div>
                        <div class="form-group">
                            <label>Last Name:</label>
                            <input type="text" v-model="NewFamily.Parent2LastName" class="form-control" required />
                        </div>
                        <div class="form-group">
                            <label>DOB:</label>
                            <flat-pickr v-model="NewFamily.Parent2DOB" class="form-control" :config="DateConfig"></flat-pickr>
                        </div>
                        <label>Sex:</label>
                        <select class="form-control" v-model="NewFamily.Parent2SexID" required>
                            <option v-for="option in SexOptions" :value="option.value">
                                {{option.text}}
                            </option>
                        </select>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="6">
                    <h2>Family Information</h2>
                    <div class="form-group">
                        <label>Family Name: <font-awesome-icon :icon="['fa', 'robot']" @click="GenerateFamilyName" class="pointer" /></label>
                        <input type="text" v-model="NewFamily.ResourceFamilyName" class="form-control" required />
                    </div>
                    <div class="form-group">
                        <label>Physical Address:</label>
                        <input type="text" v-model="NewFamily.ResourceFamilyPhysicalAddressLine1" class="form-control" placeholder="Address Line 1" />
                        <input type="text" v-model="NewFamily.ResourceFamilyPhysicalAddressLine2" class="form-control" placeholder="Address Line 2 (optional)" />
                        <b-row>
                            <div class="col-5 no-padding">
                                <input type="text" v-model="NewFamily.ResourceFamilyPhysicalCity" class="form-control" placeholder="City" />
                            </div>
                            <div class="col-3 no-padding">
                                <select class="form-control" v-model="NewFamily.ResourceFamilyPhysicalState">
                                    <option v-for="option in StateOptions" :value="option.value">
                                        {{option.text}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-4 no-padding">
                                <input type="text" v-model="NewFamily.ResourceFamilyPhysicalZip" class="form-control" placeholder="Zip" />
                            </div>
                    </div>
                    <div class="form-group">
                        <label>Mailing Address: <font-awesome-icon :icon="['fa', 'robot']" @click="CopyPhysicalAddress()" class="pointer" /></label>
                        <input type="text" v-model="NewFamily.ResourceFamilyMailingAddressLine1" class="form-control" placeholder="Address Line 1" />
                        <input type="text" v-model="NewFamily.ResourceFamilyMailingAddressLine2" class="form-control" placeholder="Address Line 2 (optional)" />
                        <b-row>
                            <div class="col-5 no-padding">
                                <input type="text" v-model="NewFamily.ResourceFamilyMailingCity" class="form-control" placeholder="City" />
                            </div>
                            <div class="col-3 no-padding">
                                <select class="form-control" v-model="NewFamily.ResourceFamilyMailingState">
                                    <option v-for="option in StateOptions" :value="option.value">
                                        {{option.text}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-4 no-padding">
                                <input type="text" v-model="NewFamily.ResourceFamilyMailingZip" class="form-control" placeholder="Zip" />
                            </div>
                    </div>
                    <div class="form-group">
                        <label>County:</label>
                        <v-select :options="CountyOptions" label="text" :reduce="option => option.value" v-model="NewFamily.ResourceFamilyCounty"></v-select>
                    </div>
                </b-col>
                <b-col lg="6">
                    <h2>Regional Program Enrollment</h2>
                    <div class="form-group">
                        <label>Regional Foster Program:</label>
                        <select class="form-control" v-model="NewFamily.SubProgramID" required>
                            <option v-for="option in SubProgramOptions" :value="option.value">
                                {{option.text}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Start Date (date of inquiry/referral)</label>
                        <flat-pickr v-model="NewFamily.StartDate" class="form-control" :config="DateConfig" required></flat-pickr>
                    </div>
                    <div class="form-group">
                        <label>Referral Source:</label>
                        <select v-model="NewFamily.ReferralSource" required class="form-control">
                            <option value=""></option>
                            <option value="Church">Church</option>
                            <option value="KFSH">KFSH</option>
                            <option value="KWVE">KWVE</option>
                            <option value="Christian Examiner">Christian Examiner</option>
                            <option value="Christian Business Directory">Christian Business Directory</option>
                            <option value="Angels in Waiting">Angels in Waiting</option>
                            <option value="Olive Crest Foster Family">Olive Crest Foster Family</option>
                            <option value="Olive Crest Staff">Olive Crest Staff</option>
                            <option value="Special Event">Special Event</option>
                            <option value="CA Kids Connection">CA Kids Connection</option>
                            <option value="AdoptUSKids">AdoptUSKids</option>
                            <option value="County Social Services">County Social Services</option>
                            <option value="Internet Search - Google">Internet Search - Google</option>
                            <option value="Internet Search - Bing">Internet Search - Bing</option>
                            <option value="Internet Search - Yahoo">Internet Search - Yahoo</option>
                            <option value="Internet Search - DuckDuckGo">Internet Search - DuckDuckGo</option>
                            <option value="Internet Search - Other">Internet Search - Other</option>
                            <option value="Olive Crest Newsletter or Facebook">Olive Crest Newsletter or Facebook</option>
                            <option value="Word of Mouth">Word of Mouth</option>
                            <option value="Send Conference">Send Conference</option>
                            <option value="Other">Other (see notes)</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Referral Notes (optional):</label>
                        <textarea class="form-control" v-model="NewFamily.ReferralNotes" type="text" autocomplete="off" rows="3"></textarea>
                    </div>
                    <button class="btn btn-success form-control" type="submit">
                        <i class="fa fa-plus"></i> Add Family to Program
                    </button>
                </b-col>
            </b-row>
        </b-form>
    </b-col>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSearch } from '@fortawesome/free-solid-svg-icons';
    library.add(faSearch);
    import { faRedo } from '@fortawesome/free-solid-svg-icons';
    library.add(faRedo);
    import { faRobot } from '@fortawesome/free-solid-svg-icons';
    library.add(faRobot);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faMinus } from '@fortawesome/free-solid-svg-icons';
    library.add(faMinus);
    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    import { EventBus } from '../../../services/event-bus.js';
    export default {
        props: [],
        data: function () {
            return {
                PageState: "Initial",
                NewFamily: {
                    Parent1DOB: "",
                    Parent1FirstName: "",
                    Parent1LastName: "",
                    Parent1SexID: "",
                    Parent2DOB: "",
                    Parent2FirstName: "",
                    Parent2LastName: "",
                    Parent2SexID: "",
                    ResourceFamilyCounty: "",
                    ResourceFamilyName: "",
                    ResourceFamilyPhysicalAddressLine1: "",
                    ResourceFamilyPhysicalAddressLine2: "",
                    ResourceFamilyPhysicalCity: "",
                    ResourceFamilyPhysicalState: "",
                    ResourceFamilyPhysicalZip: "",
                    ResourceFamilyMailingAddressLine1: "",
                    ResourceFamilyMailingAddressLine2: "",
                    ResourceFamilyMailingCity: "",
                    ResourceFamilyMailingState: "",
                    ResourceFamilyMailingZip: "",
                    StartDate: "",
                    SubProgramID: "",
                    ReferralSource: "",
                    ReferralNotes: ""
                },
                DateConfig: {
                    dateFormat: 'm/d/Y',
                    allowInput: true,
                    required: true
                },
                Parent2On: false
            };
        },
        methods: {
            GenerateFamilyName() {
                if (this.Parent2On) {
                    if (this.NewFamily.Parent1LastName == this.NewFamily.Parent2LastName) {
                        this.NewFamily.ResourceFamilyName = this.NewFamily.Parent1LastName + ", " + this.NewFamily.Parent1FirstName + " and " + this.NewFamily.Parent2FirstName;
                    } else {
                        this.NewFamily.ResourceFamilyName = this.NewFamily.Parent1LastName + "/" + this.NewFamily.Parent2LastName + ", " + this.NewFamily.Parent1FirstName + " and " + this.NewFamily.Parent2FirstName;
                    }
                } else {
                    this.NewFamily.ResourceFamilyName = this.NewFamily.Parent1LastName + ", " + this.NewFamily.Parent1FirstName;
                }
            },
            AddFamily(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Foster/ResourceFamily/AddNewResourceFamily", this.NewFamily, this.AddFamilySuccess, () => { }, true);
            },
            AddFamilySuccess(response) {
                this.$store.commit("Families.FamilyProfiles.Append", { Family: { Id: response.data.data.FosterResourceFamilyID } });
                //this.$set(this.$parent.OpenChildRecords, subProgramMembershipID, childRecordData);
                this.$parent.ChangePaneShown(response.data.data.FosterResourceFamilyID);
                //execute global update
                this.$GlobalUpdate.ExecuteGlobalUpdate();
                //reset page state and form info
                this.ResetPage();
            },
            Parent2Toggle() {
                if (this.Parent2On == true) {
                    this.Parent2On = false;
                } else {
                    this.Parent2On = true;
                }
            },
            ResetPage() {
                this.$set(this, 'NewFamily', {
                    Parent1DOB: "",
                    Parent1FirstName: "",
                    Parent1LastName: "",
                    Parent1SexID: "",
                    Parent2DOB: "",
                    Parent2FirstName: "",
                    Parent2LastName: "",
                    Parent2SexID: "",
                    ResourceFamilyCounty: "",
                    ResourceFamilyName: "",
                    ResourceFamilyPhysicalAddressLine1: "",
                    ResourceFamilyPhysicalAddressLine2: "",
                    ResourceFamilyPhysicalCity: "",
                    ResourceFamilyPhysicalState: "",
                    ResourceFamilyPhysicalZip: "",
                    ResourceFamilyMailingAddressLine1: "",
                    ResourceFamilyMailingAddressLine2: "",
                    ResourceFamilyMailingCity: "",
                    ResourceFamilyMailingState: "",
                    ResourceFamilyMailingZip: "",
                    StartDate: "",
                    SubProgramID: "",
                    ReferralSource: "",
                    ReferralNotes: ""
                });
                this.Parent2On = false;
            },
            CopyPhysicalAddress() {
                this.NewFamily.ResourceFamilyMailingAddressLine1 = this.NewFamily.ResourceFamilyPhysicalAddressLine1; 
                this.NewFamily.ResourceFamilyMailingAddressLine2 = this.NewFamily.ResourceFamilyPhysicalAddressLine2;
                this.NewFamily.ResourceFamilyMailingCity = this.NewFamily.ResourceFamilyPhysicalCity;
                this.NewFamily.ResourceFamilyMailingState = this.NewFamily.ResourceFamilyPhysicalState
                this.NewFamily.ResourceFamilyMailingZip = this.NewFamily.ResourceFamilyPhysicalZip;
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
            vSelect
        },
        computed: {
            SexOptions: function () {
                return this.$store.state.Options.Sexes;
            },
            CountyOptions: function () {
                return this.$store.state.Options.CaliforniaCounties;
            },
            StateOptions: function () {
                return this.$store.state.Options.USStateAbbreviations;
            },
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
        }
    }
</script>

<style scoped>
    .no-padding:first-child  {
        padding-right: 0px;
    }
    .no-padding:last-child  {
        padding-left: 0px;
    }
</style>